// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/relationship.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message mlmbox.types.Relationship
 */
export interface Relationship {
    /**
     * @generated from protobuf field: mlmbox.types.Relationship.Kind kind = 1;
     */
    kind: Relationship_Kind;
    /**
     * @generated from protobuf field: uint32 level = 2;
     */
    level: number; // Depth level
    /**
     * @generated from protobuf field: uint32 branch = 3;
     */
    branch: number; // Branch id
}
/**
 * @generated from protobuf enum mlmbox.types.Relationship.Kind
 */
export enum Relationship_Kind {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * Personal account/position
     *
     * @generated from protobuf enum value: PERSONAL = 1;
     */
    PERSONAL = 1,
    /**
     * Account/position is in the structure
     *
     * @generated from protobuf enum value: TEAM = 2;
     */
    TEAM = 2,
    /**
     * Account/position is superior in the structure
     *
     * @generated from protobuf enum value: REFERRAL = 3;
     */
    REFERRAL = 3,
    /**
     * Account/position is outside the structure
     *
     * @generated from protobuf enum value: OUTSIDER = 4;
     */
    OUTSIDER = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class Relationship$Type extends MessageType<Relationship> {
    constructor() {
        super("mlmbox.types.Relationship", [
            { no: 1, name: "kind", kind: "enum", T: () => ["mlmbox.types.Relationship.Kind", Relationship_Kind] },
            { no: 2, name: "level", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 3, name: "branch", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<Relationship>): Relationship {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.kind = 0;
        message.level = 0;
        message.branch = 0;
        if (value !== undefined)
            reflectionMergePartial<Relationship>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Relationship): Relationship {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* mlmbox.types.Relationship.Kind kind */ 1:
                    message.kind = reader.int32();
                    break;
                case /* uint32 level */ 2:
                    message.level = reader.uint32();
                    break;
                case /* uint32 branch */ 3:
                    message.branch = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Relationship, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* mlmbox.types.Relationship.Kind kind = 1; */
        if (message.kind !== 0)
            writer.tag(1, WireType.Varint).int32(message.kind);
        /* uint32 level = 2; */
        if (message.level !== 0)
            writer.tag(2, WireType.Varint).uint32(message.level);
        /* uint32 branch = 3; */
        if (message.branch !== 0)
            writer.tag(3, WireType.Varint).uint32(message.branch);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Relationship
 */
export const Relationship = new Relationship$Type();
